import { Inject, Injectable, Injector } from '@angular/core';
import { tap } from 'rxjs';
import {
  MetodoPagamentoResponse,
  PlanoDePagamentoResponse,
} from '../../../models/plano-de-pagamento.models';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { VendedorSelectService } from '../vendedor-service/vendedor-service.service';

@Injectable({
  providedIn: 'root',
})
export class NewApiPlanoPagamentoService extends UtilsBaseApiService<NewApiPlanoPagamentoService> {
  readonly METODO_DE_PAGAMENTO_CONTEXT = 'metodo_de_pagamento';
  readonly BY_ID_COBRANCA = 'by_id_cobranca';
  planoPagamentoOptions: MetodoPagamentoResponse[] = [];
  tipoDeCobrancaOptions: PlanoDePagamentoResponse[] = [];

  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
    private readonly vendedorSelectUse: VendedorSelectService
  ) {
    super('plano_de_pagamento', injector, environment.BASE_API_URL);
  }

  getMethodsOfPayment(matricula: number, codigoCliente: number, id_filial: string) {
    return this.httpClient
      .get<MetodoPagamentoResponse[]>(
        `${this.BASE_URL}${this.CONTEXT}/${this.METODO_DE_PAGAMENTO_CONTEXT}?${this.getQueryString({matricula, codigoCliente, id_filial})}`
      )
      .pipe(
        tap((response) => {
          this.planoPagamentoOptions = response;
        })
      );
  }

  getByIdCobranca(idCobranca: string, id_filial: string, idvend?: number, idClient?: number) {
    return this.httpClient
      .get<PlanoDePagamentoResponse[]>(
        `${this.BASE_URL}${this.CONTEXT}/${this.BY_ID_COBRANCA}?${this.getQueryString({idCobranca, idvend, idClient, id_filial})}`
      )
      .pipe(
        tap((response) => {
          this.tipoDeCobrancaOptions = response;
        })
      );
  }
}
